import React, { useState } from "react";
import axios from "axios";

/*
  ✅ IMPORTANT FOR DEV vs VPS

  In development:
    REACT_APP_API_URL=

  On VPS:
    REACT_APP_API_URL=https://mysticmegabyte.com

  Put this in:
    client/.env
    client/.env.production

  Never hardcode localhost again 👍
*/
const API_URL =
  process.env.REACT_APP_API_URL || "";

const FeedbackBox = ({ type }) => {
  const [rating, setRating] = useState(null);
  const [comment, setComment] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!rating) return;

    try {
      setLoading(true);

      const token = localStorage.getItem("token");

      await axios.post(
        `${API_URL}/api/feedback`,
        { type, rating, comment },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      setSent(true);
    } catch (err) {
      console.error("Feedback failed:", err);
      alert("Could not send feedback — please try again.");
    } finally {
      setLoading(false);
    }
  };

  // Success message
  if (sent) {
    return (
      <div className="bg-green-900 bg-opacity-30 p-4 rounded-xl mt-4 text-green-200">
        Thank you — your feedback helps refine Mysticmegabyte ✨
      </div>
    );
  }

  return (
    <div className="bg-black bg-opacity-30 p-4 rounded-xl mt-4">
      <h4 className="font-semibold mb-2">
        Did this resonate today?
      </h4>

      {/* Rating buttons */}
      <div className="flex gap-3 mb-3">
        {[
          { key: "very", label: "✨ Very much" },
          { key: "somewhat", label: "🙂 Somewhat" },
          { key: "not", label: "😕 Not really" },
        ].map((r) => (
          <button
            key={r.key}
            onClick={() => setRating(r.key)}
            className={`px-3 py-1 rounded-lg transition
              ${
                rating === r.key
                  ? "bg-purple-500 text-white"
                  : "bg-purple-900 bg-opacity-30 hover:bg-purple-800"
              }
            `}
          >
            {r.label}
          </button>
        ))}
      </div>

      {/* Optional comment */}
      <textarea
        placeholder="Optional: anything you'd like to share?"
        value={comment}
        onChange={(e) => setComment(e.target.value)}
        className="w-full bg-black bg-opacity-20 rounded p-2 text-white text-sm"
        rows={2}
      />

      {/* Submit */}
      <button
        disabled={!rating || loading}
        onClick={submit}
        className="mt-3 bg-purple-500 hover:bg-purple-600 disabled:opacity-40 px-4 py-2 rounded font-semibold"
      >
        {loading ? "Sending…" : "Submit feedback"}
      </button>
    </div>
  );
};

export default FeedbackBox;
